export const language: any = {
  selected_ingredients: 'ရွေးချယ်ထားသော အစားအစာပစ္စည်းများ',
  recommend: 'အကြံပြုထားသော အစားအစာများ',
  title_detail: 'အကြံပြုထားသော ရုပ်ပုံများ',
  share: 'မျှဝေပါ',
  ingredients: {
    title: `<span class="tracking-tighter whitespace-nowrap">အစားအစာပစ္စည်းများ</span> <span class="tracking-tighter whitespace-nowrap">(၁ ယူနစ်)</span>`,
    add_all: 'အစားအစာပစ္စည်းအားလုံးကို ထည့်ပါ',
    view_more: '{number} ပိုသော အစားအစာပစ္စည်းများကို ကြည့်ပါ',
    view_less: 'ပိတ်ပါ',
    delete_all: 'အစားအစာပစ္စည်းအားလုံးကို ဖျက်ပါ',
  },
  how_to_cook: 'ချက်ပြုတ်နည်း',
  video: {
    title: 'ဗီဒီယို ဟင်းလျာ',
  },
  msg: {
    msg_1: "ဤအစားအစာပစ္စည်းကို ဖျက်လိုပါသလား?",
    msg_2: "အစားအစာပစ္စည်းအားလုံးကို ဖျက်လိုပါသလား?",
    msg_3: "ဤအစားအစာပစ္စည်းများကို ထည့်လိုပါသလား?",
    msg_4: "ပျောက်ဆုံးနေသော အစားအစာပစ္စည်းအားလုံးကို ထည့်လိုပါသလား?",
    msg_5: "ရွေးချယ်ထားသော အစားအစာပစ္စည်းများကို သင်၏ အဝယ်စာရင်းသို့ ထည့်လိုပါသလား?",
    msg_6: "ဤအစားအစာပစ္စည်းသည် သင်၏ အဝယ်စာရင်းတွင် ရှိပါပြီ။",
    confirm: "ဟုတ်ပါသည်",
    cancel: "မဟုတ်ပါ",
  },
  recipe_exist_in_cart: "ဤအစားအစာပစ္စည်းသည် သင်၏ အဝယ်စာရင်းတွင် ရှိပါပြီ။",
  recipe_want_add_to_cart: "ရွေးချယ်ထားသော အစားအစာပစ္စည်းများကို သင်၏ အဝယ်စာရင်းသို့ ထည့်လိုပါသလား?",
  recipe_exist_in_cart_should_exclued: "သည် လက်ရှိစျေးခြင်းထဲတွင် ရှိပြီးဖြစ်သောကြောင့် ဖယ်ရှားခဲ့သည်။",
  calories_description: "ဒီအစားအစာကို အောက်ပါချက်ပြုတ်နည်းအရ {calories} ကယ်လိုရီပါမည်ဟု ခန့်မှန်းထားပါသည်။ သင့်ကျန်းမာရေးအတွက်မှန်ကန်သောရွေးချယ်မှုကိုစဉ်းစားပါ။",
  title_share_sns: "ဤချက်ပြုတ်ချက်ကို မျှဝေပါ",
  copy: "ကူးယူပါ",
  recipe_add_cart_success: "စျေးဝယ်ခြင်းတွင်ထည့်ပြီးပါပြီ။ စျေးဝယ်ခြင်းပုံစံသို့သွားလိုပါသလား?",
  recipe_close: "ပိတ်မည်",
  recipe_move: "ရွှေ့မည်",
  recipe_add_ingredient_success: "ရွေးချယ်ထားသောပစ္စည်းများထည့်ပြီးပါပြီ။ ပစ္စည်းစာမျက်နှာသို့ပြောင်းလိုပါသလား?",
  copied: "ကူးယူပြီးပါပြီ",
  text_share_sns: `{recipe_name} ဒီဟင်းချက်နည်းကဘယ်လိုလဲ။\nHey! Cooker မှာ စစ်ဆေးကြည့်ပါ!`,
  search:{
    title: "ချက်ပြုတ်နည်းများ ရှာဖွေရန်",
    searching: "Hey Cooker သင့်ရဲ့ စကားလုံးနဲ့ ကိုက်ညီတဲ့ချက်ပြုတ်နည်းတွေကို ရှာနေပါတယ်၊ ခဏစောင့်ပေးပါ!",
    not_found: "ဟုံ AI ချက်ပြုတ်မောင်သည် သင့်ရဲ့ စကားလုံးနဲ့ ကိုက်ညီတဲ့ချက်ပြုတ်နည်းတွေကို မတွေ့နိုင်ပါ။ အခြားသောမုန့်အမည်ကို ထပ်မံထည့်ကြည့်ပါ။",
    placeholder: "သင်ရှာဖွေနိုင်သော ချက်ပြုတ်နည်းအမည်ကိုထည့်ပါ...",
    msg_default_recipe: "သင့်တွင် မည်သည့်ချက်ပြုတ်နည်းမျှ မရှိပါ",
  },
  noData: "ရလဒ်မရှိပါ",
  searching: "ရှာနေပါသည်..."
}
